import create from "zustand";

const useAppStore = create((set) => ({
  socket: null,
  storageClient: null,
  accessToken: sessionStorage.getItem("accessToken") ?? null,
  liveAvatarSessionToken: sessionStorage.getItem("liveAvatarSessionToken") ?? null,
  modelTextInputStream: null,
  modelTextInputReader: null,
  modelTextInputController: null,
  modelCaptionsStream: null,
  modelCaptionsReader: null,
  modelCaptionsController: null,
  avatarVideoStream: null,
  botAudioOnlyStream: null,
  isUltravoxAgentNodeAvailable: false,
  scriptProcessor: null,
  displayBotVisualizer: null,
  conversations: [],
  canInitializeMediaStream: false,
  endInterviewAfterSynthesis: false,
  isSetupDone: false,
  isSocketInitialized: false,
  shouldStartTheInterview: false,
  botResponse: null,
  userResponse: null,
  interviewEnded:false,
  canEndServerSessionForLiveAvatar:true,
  screenSize:"sm",
  permissions: {
    webcam: { allowed: false, stream: null },
    microphone: { allowed: false, stream: null },
    tabDisplayRecording: { allowed: false, stream: null },
    userAudioForDisplayStream: { allowed: false, stream: null },
    micStream: { stream: null },
    isTestPassed: false,
    allPermissionsGranted: false,
  },
  setScreenSize: (value) =>
    set(() => ({
      screenSize: value,
    })),
  setCanEndServerSessionForLiveAvatar: (value) =>
    set(() => ({
      canEndServerSessionForLiveAvatar: value,
    })),
  setInterviewEnded: (value) =>
    set(() => ({
      interviewEnded: value,
    })),
  setBotResponse: (value) =>
    set(() => ({
      botResponse: value,
    })),
  setUserResponse: (value) =>
    set(() => ({
      userResponse: value,
    })),
  setShouldStartTheInterview: (value) =>
    set(() => ({
      shouldStartTheInterview: value,
    })),
  setIsSocketInitialized: (value) =>
    set(() => ({
      isSocketInitialized: value,
    })),
  setIsSetupDone: (value) =>
    set(() => ({
      isSetupDone: value,
    })),
  setEndInterviewAfterSynthesis: (value) =>
    set(() => ({
      endInterviewAfterSynthesis: value,
    })),
  setCanInitializeMediaStream: (value) =>
    set(() => ({
      canInitializeMediaStream: value,
    })),
  setConversations: (value) =>
    set(() => ({
      conversations: value,
    })),
  addMessage: (speaker, message, isBot) => {
    if (message?.length > 0) {
      console.log(`[AppStore] Adding message to conversation:`, {
        speaker,
        messageLength: message.length,
        isBot,
        timestamp: new Date().toLocaleTimeString()
      });
      set((state) => ({
        conversations: [
          ...state.conversations,
          {
            speaker: speaker,
            message: message,
            time: new Date().toLocaleTimeString(),
            isBot: isBot,
          },
        ],
      }));
    }
  },
  setPermission: (type, allowed, stream = null, value) => {
    console.log(`[AppStore] Setting permission:`, { type, allowed, hasStream: !!stream, value });
    if (type === "isTestPassed") {
      set((state) => ({
        permissions: {
          ...state.permissions,
          [type]: value,
        },
      }));
    } else if (type === "allPermissionsGranted") {
      set((state) => ({
        permissions: {
          ...state.permissions,
          [type]: value,
        },
      }));
    } else {
      set((state) => ({
        permissions: {
          ...state.permissions,
          [type]: { allowed, stream },
        },
      }));
    }
  },
  setAccessToken: (value) => {
    console.log(`[AppStore] Setting access token:`, { hasToken: !!value });
    sessionStorage.setItem("accessToken", value);
    return set(() => ({
      accessToken: value,
    }));
  },
  setUserMicInputStream: (data) => {
    console.log(`[AppStore] Setting user mic input stream:`, { hasStream: !!data });
    return set({ userMicInputStream: data });
  },
  setModelTextInputStream: (data) => set({ modelTextInputStream: data }),
  setModelCaptionsStream: (data) => set({ modelCaptionsStream: data }),
  setScriptProcessor: (data) => set({ scriptProcessor: data }),
  setModelTextInputReader: (data) => set({ modelTextInputReader: data }),
  setModelTextInputController: (data) =>
    set({ modelTextInputController: data }),
  setModelCaptionsReader: (data) => set({ modelCaptionsReader: data }),
  setModelCaptionsController: (data) =>
    set({ modelCaptionsController: data }),
  setDisplayBotVisualizer: (data) => set({ displayBotVisualizer: data }),
  setLiveAvatarSessionToken: (value) => {
    console.log(`[AppStore] Setting LiveAvatar session token:`, { hasToken: !!value });
    sessionStorage.setItem("liveAvatarSessionToken", value);
    return set(() => ({
      liveAvatarSessionToken: value,
    }));
  },
  setSocket: (value) =>
    set(() => ({
      socket: value,
    })),
  setStorageClient: (value) =>
    set(() => ({
      storageClient: value,
    })),
  setAvatarVideoStream: (value) =>
    set(() => ({
      avatarVideoStream: value,
    })),
  setBotAudioOnlyStream: (value) =>
    set(() => ({
      botAudioOnlyStream: value,
    })),
  setIsUltravoxAgentNodeAvailable: (value) =>
    set(() => ({
      isUltravoxAgentNodeAvailable: value,
    })),
}));

export default useAppStore;
